<form>
  <div class="row">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive our-table">
        <table class="table table-striped text-nowrap mb-0">
          <thead class="border-top">
            <tr>
              <th scope="col" class="text-capitalize">Data</th>
              <th scope="col" class="text-capitalize">Usuário</th>
              <th scope="col" class="text-capitalize">IP</th>
              <th scope="col" class="text-capitalize">Tipo</th>
              <th scope="col" class="text-capitalize">Conta</th>
              <th scope="col" class="text-capitalize">Transação</th>
            </tr>
          </thead>

          <tbody>
            <tr class="border-bottom" *ngFor="let log of logs">
              <td>
                <span>{{ log.dateExecution | date : "dd/MM/yyyy HH:mm:ss" : "GMT" }}</span>
              </td>
              <td><span>{{ log.user || '-' }}</span></td>
              <td><span>{{ log.ip || '-' }}</span></td>
              <td><span>{{ log.type || '-' }}</span></td>
              <td><span>{{ log.account }}</span></td>
              <td><span>{{ log.idTransaction }}</span></td>
            </tr>

            <tr *ngIf="logs.length === 0">
              <td colspan="6">{{ "common.noData" | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between p-2">
        <ngb-pagination
          [collectionSize]="total"
          [maxSize]="5"
          [rotate]="true"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="pageChange()"
        >
        </ngb-pagination>
      </div>
    </div>
  </div>
</form>